import { useEffect, useState } from "react";
import { listarResponsaveis } from "../api/turmas";
import { getUsuarioLogadoAdaptado, idsIguais } from "../utils/ids";

// Todas as permissões são POR TURMA (gravadas no VinculoResponsavel):
//   - podeCriarEditarEventos
//   - podeEditarListaAlunos
//   - podeGerenciarResponsaveis
// Coordenador sempre pode. Demais (responsável / aluno-responsável) dependem da
// flag do seu vínculo NAQUELA turma.
//
// Retorna { carregando, pode }. Enquanto carrega, pode=true para não piscar
// bloqueio antes de saber a permissão real.
export function usePermissaoTurma(turmaId, campo) {
  const [pode, setPode] = useState(true);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const usuario = getUsuarioLogadoAdaptado();
    const tipo = String(usuario?.tipo || "").toLowerCase();

    // Coordenador: acesso total, sem checagem.
    if (tipo === "coordenador") {
      setPode(true);
      setCarregando(false);
      return;
    }

    if (!turmaId || !usuario?.id) {
      // Sem turma de contexto não há como validar — bloqueia por segurança.
      setPode(false);
      setCarregando(false);
      return;
    }

    let vivo = true;
    setCarregando(true);
    (async () => {
      try {
        const lista = await listarResponsaveis(turmaId);
        if (!vivo) return;
        const meuVinculo = (Array.isArray(lista) ? lista : []).find((v) =>
          idsIguais(v.userId, usuario.id),
        );
        setPode(!!meuVinculo?.[campo]);
      } catch {
        if (vivo) setPode(false);
      } finally {
        if (vivo) setCarregando(false);
      }
    })();
    return () => {
      vivo = false;
    };
  }, [turmaId, campo]);

  return { carregando, pode };
}
